export function MainContent(props: any) {
  return (
    <div className="mainContent">
      {props.children}
    </div>
  );
}
